module.exports = "/_next/static/images/Hero@2x-5336a0dc6216f47185515c69c8f3842a.webp";